import * as React from 'react';
import { createContext, useContext } from 'react';
import styled, { css } from 'styled-components';
import { normalise } from '@lendi-ui/utils';
import { bg } from '@lendi-ui/color';
import { depth } from '@lendi-ui/depth';
import { jsx } from 'react/jsx-runtime';
import Sticky from 'react-stickynode';

var ChildrenWrapper = styled.div.withConfig({
  displayName: "indexstyle__ChildrenWrapper",
  componentId: "lui__sc-48r6gj-0"
})(["", ";padding:0;display:flex;flex-direction:row;align-items:center;width:100%;", ""], normalise, _ref => {
  var {
    isTransparent
  } = _ref;
  return css(["", ";"], isTransparent ? "background-color: transparent;" : css(["", " ", ";"], depth(2), bg('shade.0')));
});
var NavbarLeftWrapper = styled.div.withConfig({
  displayName: "indexstyle__NavbarLeftWrapper",
  componentId: "lui__sc-48r6gj-1"
})(["margin-right:auto;"]);
var NavbarRightWrapper = styled.div.withConfig({
  displayName: "indexstyle__NavbarRightWrapper",
  componentId: "lui__sc-48r6gj-2"
})(["margin-left:auto;"]);

var NavbarLeft = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/jsx(NavbarLeftWrapper, {
    children: children
  });
};

var NavbarRight = _ref => {
  var {
    children
  } = _ref;
  return /*#__PURE__*/jsx(NavbarRightWrapper, {
    children: children
  });
};

var NavbarBaseContext = /*#__PURE__*/createContext(undefined);
var useNavbarBaseContext = () => {
  var context = useContext(NavbarBaseContext);

  if (!context) {
    throw new Error("NavbarBase compound components cannot be rendered outside the NavbarBase component");
  }

  return context;
};

var NavbarBase = _ref => {
  var {
    children,
    isTransparent: useTransparent = false,
    className
  } = _ref;
  var [isTransparent, setIsTransparent] = React.useState(useTransparent);
  React.useEffect(() => {
    setIsTransparent(useTransparent);
  }, [useTransparent]);

  var handleStickyState = _ref2 => {
    var {
      status
    } = _ref2;

    if (useTransparent) {
      if (status === Sticky.STATUS_FIXED) {
        setIsTransparent(false);
      } else {
        setIsTransparent(true);
      }
    }
  };

  return /*#__PURE__*/jsx("nav", {
    "aria-label": "Main navigation",
    children: /*#__PURE__*/jsx(NavbarBaseContext.Provider, {
      value: {
        isTransparent
      },
      children: /*#__PURE__*/jsx(Sticky, {
        innerZ: 3,
        onStateChange: handleStickyState,
        children: /*#__PURE__*/jsx(ChildrenWrapper, {
          isTransparent: isTransparent,
          className: className,
          children: children
        })
      })
    })
  });
};

NavbarBase.Left = NavbarLeft;
NavbarBase.Right = NavbarRight;

export { NavbarBase, NavbarBaseContext, NavbarBase as default, useNavbarBaseContext };
